// The Seal lexical word lists, shared by the Monaco language (sealLanguage.ts)
// and the lightweight search-result highlighter (sealHighlight.ts) so the two
// never drift. Plain data, no dependencies.

/** Reserved words that begin / structure a declaration. */
export const KEYWORDS = [
  "contract",
  "spend",
  "require",
  "extern",
  "const",
  "keypath",
  "after",
  "open",
  "relaxed",
  "in",
  "where",
];

/** Declaration / value types. */
export const TYPES = [
  "Int",
  "Bool",
  "PublicKey",
  "Signature",
  "Hash",
  "Bytes",
  "LockTime",
  "Sha256",
  "Hash160",
];

/** Builtin functions, namespaced constructors, and literals. */
export const BUILTINS = [
  "sha256",
  "hash160",
  "ripemd160",
  "sum",
  "count",
  "fold",
  "select",
  "check",
  "MuSig2",
  "None",
];

export const LITERALS = ["true", "false"];
